import * as types from './type'
import * as api from './api'

export default {
  state: {
    account_detail: [],
    withdraw_info: {
      amount: '',
      count: ''
    },
    account_info: {
      balance: '',
      total: ''
    },
    wechat_info: {
      wechat_realname: ''
    },
    amount: 0,
    mobile: '',
    dateMembers: [],
    incomeMembers: [],
    unreceived_rewards: [],
    received_rewards: [],
    invalid_rewards: []
  },
  mutations: {
    setAccountState (state, payload) {
      state.account_detail = payload.account_detail
      state.withdraw_info = payload.withdraw_info
      state.account_info = payload.account_info
      state.wechat_info = payload.wechat_info
      state.mobile = payload.mobile
    },
    accountState (state, obj) {
      state[obj.key] = obj.val
    }
  },
  actions: {
    // 用户账户信息
    async [types.URI_USER_ACCOUNT] ({ commit }, params) {
      const res = await api.accountInfo(params)
      if (res && res.status === 200) {
        commit('setAccountState', res.data.payload)
      }
      return res
    },
    // 微信提现
    async [types.URI_WECHAT_WITHDRAW] ({ commit }, params) {
      const res = await api.wechatWithdraw(params)
      if (res && res.status === 200) {
        return res
      }
    },
    // 我的队员-按日期
    async [types.URI_MEMBER_DATE] ({ commit }, params) {
      const res = await api.memberDateList(params)
      if (res && res.status === 200) {
        commit('accountState', { key: 'dateMembers', val: res.data.payload })
      }
      return res
    },
    // 我的队员-按收入
    async [types.URI_MEMBER_INCOME] ({ commit }, params) {
      const res = await api.memberIncomeList(params)
      if (res && res.status === 200) {
        commit('accountState', { key: 'incomeMembers', val: res.data.payload })
      }
      return res
    },
    // 我的提成
    async [types.URI_MY_COMMISION] ({ commit }, params) {
      const res = await api.getCommision(params)
      if (res && res.status === 200) {
        commit('accountState', { key: 'unreceived_rewards', val: res.data.payload.unreceived_rewards })
        commit('accountState', { key: 'received_rewards', val: res.data.payload.received_rewards })
        commit('accountState', { key: 'invalid_rewards', val: res.data.payload.invalid_rewards })
      }
      return res
    },
    // 我的提成-更多
    async [types.URI_MORE_COMMISSION] ({ commit }, params) {
      const res = await api.getMoreCommission(params)
      if (res && res.status === 200) {
        let rewards = res.data.payload.rewards
        if (params.tab === 1) {
          commit('accountState', { key: 'unreceived_rewards', val: rewards })
        } else if (params.tab === 2) {
          commit('accountState', { key: 'received_rewards', val: rewards })
        } else {
          commit('accountState', { key: 'invalid_rewards', val: rewards })
        }
      }
      return res
    },
    // 团队提成
    async [types.URI_TEAM_REWARD] ({ commit }, params) {
      const res = await api.teamReward(params)
      if (res && res.status === 200) {
        commit('accountState', { key: 'amount', val: res.data.payload })
      }
      return res
    }
  }
}
